import React from 'react';

import { cn } from '../../lib/utils';

/**
 * Pièces communes des écrans du poste et de la journée (lot 030) : un panneau
 * à titre (et aide facultative), le gabarit des tableaux (chiffres à droite),
 * un champ étiqueté.
 */
export const CELLULES =
  'w-full border-collapse text-sm [&_td]:border-b [&_td]:border-border/60 [&_td]:px-3 [&_td]:py-2 [&_th]:whitespace-nowrap [&_th]:border-b [&_th]:border-border [&_th]:px-3 [&_th]:py-1.5 [&_th]:text-xs [&_th]:font-semibold [&_th]:text-muted-foreground [&_tfoot_td]:border-0 [&_tfoot_td]:font-semibold';

export const Panneau = ({ titre, aide, droite, children, className = '' }) => (
  <section className={`flex h-full flex-col rounded-xl border border-border bg-card shadow-sm ${className}`}>
    <header className="flex flex-wrap items-baseline justify-between gap-2 px-4 pb-2 pt-3">
      <h2 className="flex items-center gap-1 text-base font-semibold">
        {titre}
        {aide}
      </h2>
      {droite}
    </header>
    <div className="flex min-h-0 flex-1 flex-col overflow-x-auto overscroll-y-contain px-1 pb-3">{children}</div>
  </section>
);

/**
 * Un panneau sans contenu : une icône et une phrase courte, centrées, qui
 * remplissent la hauteur du panneau (celui d'à côté fixe la hauteur de la rangée).
 */
export const PanneauVide = ({ icone: Icone, texte, className }) => (
  <div className={cn('flex flex-1 flex-col items-center justify-center gap-2 px-3 py-6 text-center text-sm text-muted-foreground', className)}>
    {Icone ? <Icone className="h-8 w-8 opacity-50" aria-hidden="true" /> : null}
    <p className="m-0">{texte}</p>
  </div>
);

export const Champ = ({ id, label, aide, children }) => (
  <div className="grid gap-1.5">
    <label htmlFor={id} className="flex items-center gap-1 text-sm font-medium text-foreground">
      {label}
      {aide}
    </label>
    {children}
  </div>
);

export default Panneau;
